module.exports = __webpack_public_path__ + "static/hyperv_33.28a8545f.jpg";